import { render, staticRenderFns } from "./opsgenie.vue?vue&type=template&id=20bbf06e&scoped=true&"
import script from "./opsgenie.vue?vue&type=script&lang=js&"
export * from "./opsgenie.vue?vue&type=script&lang=js&"
import style0 from "./opsgenie.vue?vue&type=style&index=0&id=20bbf06e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20bbf06e",
  null
  
)

export default component.exports